import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { GetCommanWay, UpdateCommanWay, CreateCommanWay } from "API/commonApi";
import Spinner from "utils/Spinner";

// Translations
const translations = {
  en: {
    title: "Mother Bag POD",
    loading: "Loading...",
    notFound: "Mother Bag not found",
    invalidLink: "Invalid or expired link",
    origin: "Origin",
    destination: "Destination",
    totalAwb: "Total AWB",
    totalWeight: "Total Weight",
    status: "Status",
    outscanPending: "Outscan Pending",
    outscanPendingMsg: "This motherbag has not been outscan yet. Please wait for outscan to complete.",
    inscanPending: "Inscan Pending",
    inscanPendingMsg: "This motherbag is ready for inscan. Click the button below to mark inscan complete.",
    markInscan: "Mark Inscan Complete",
    inscanComplete: "Inscan Complete",
    awbList: "AWB List for POD",
    selectAll: "Select All",
    awbNo: "AWB No",
    consignee: "Consignee",
    weight: "Weight",
    delivered: "Delivered",
    pending: "Pending",
    noAwb: "No pending AWB for POD",
    allDelivered: "All AWBs have been delivered!",
    selectedAwb: "Selected AWB",
    receiverName: "Receiver Name",
    receiverMobile: "Receiver Mobile",
    enterReceiverName: "Enter receiver name",
    enterReceiverMobile: "Enter 10 digit mobile number",
    submitPod: "Submit POD",
    cancel: "Cancel",
    success: "Success",
    podSuccess: "POD updated successfully!",
    inscanSuccess: "Inscan marked successfully!",
    inscanConfirm: "Confirm Bag Receipt",
    inscanConfirmMsg: "Are you sure you want to mark this motherbag as received?",
    yes: "Yes, Confirm",
    no: "No, Cancel",
    error: "Error",
    tryAgain: "Please try again",
    kg: "kg",
  },
  hi: {
    title: "मदर बैग POD",
    loading: "लोड हो रहा है...",
    notFound: "मदर बैग नहीं मिला",
    invalidLink: "अमान्य या समाप्त लिंक",
    origin: "मूल स्थान",
    destination: "गंतव्य",
    totalAwb: "कुल AWB",
    totalWeight: "कुल वजन",
    status: "स्थिति",
    outscanPending: "आउटस्कैन लंबित",
    outscanPendingMsg: "इस मदरबैग का आउटस्कैन अभी नहीं हुआ है। कृपया आउटस्कैन पूर्ण होने की प्रतीक्षा करें।",
    inscanPending: "बैग स्वीकार बाकी",
    inscanPendingMsg: "यह मदरबैग स्वीकार करने के लिए तैयार है। बैग स्वीकार करने के लिए नीचे बटन दबाएं।",
    markInscan: "बैग स्वीकार करें",
    inscanComplete: "बैग स्वीकार पूर्ण",
    awbList: "POD के लिए AWB सूची",
    selectAll: "सभी चुनें",
    awbNo: "AWB नंबर",
    consignee: "प्राप्तकर्ता",
    weight: "वजन",
    delivered: "डिलीवर",
    pending: "लंबित",
    noAwb: "POD के लिए कोई AWB नहीं",
    allDelivered: "सभी AWB डिलीवर हो गए!",
    selectedAwb: "चयनित AWB",
    receiverName: "प्राप्तकर्ता का नाम",
    receiverMobile: "प्राप्तकर्ता का मोबाइल",
    enterReceiverName: "प्राप्तकर्ता का नाम दर्ज करें",
    enterReceiverMobile: "10 अंकों का मोबाइल नंबर दर्ज करें",
    submitPod: "POD जमा करें",
    cancel: "रद्द करें",
    success: "सफल",
    podSuccess: "POD सफलतापूर्वक अपडेट हुआ!",
    inscanSuccess: "बैग स्वीकार सफलतापूर्वक पूर्ण!",
    inscanConfirm: "बैग प्राप्ति की पुष्टि करें",
    inscanConfirmMsg: "क्या आप सुनिश्चित हैं कि आप इस मदरबैग को प्राप्त के रूप में चिह्नित करना चाहते हैं?",
    yes: "हाँ, पुष्टि करें",
    no: "नहीं, रद्द करें",
    error: "त्रुटि",
    tryAgain: "कृपया पुनः प्रयास करें",
    kg: "किलो",
  },
  gu: {
    title: "મધર બેગ POD",
    loading: "લોડ થઈ રહ્યું છે...",
    notFound: "મધર બેગ મળ્યું નથી",
    invalidLink: "અમાન્ય અથવા સમાપ્ત લિંક",
    origin: "મૂળ સ્થાન",
    destination: "ગંતવ્ય",
    totalAwb: "કુલ AWB",
    totalWeight: "કુલ વજન",
    status: "સ્થિતિ",
    outscanPending: "આઉટસ્કેન બાકી",
    outscanPendingMsg: "આ મધરબેગનું આઉટસ્કેન હજુ થયું નથી. કૃપા કરીને આઉટસ્કેન પૂર્ણ થવાની રાહ જુઓ.",
    inscanPending: "બેગ સ્વીકારો બાકી",
    inscanPendingMsg: "આ મધરબેગ સ્વીકારવા માટે તૈયાર છે. બેગ સ્વીકારવા નીચે બટન દબાવો.",
    markInscan: "બેગ સ્વીકારો",
    inscanComplete: "બેગ સ્વીકાર પૂર્ણ",
    awbList: "POD માટે AWB યાદી",
    selectAll: "બધા પસંદ કરો",
    awbNo: "AWB નંબર",
    consignee: "પ્રાપ્તકર્તા",
    weight: "વજન",
    delivered: "ડિલિવર",
    pending: "બાકી",
    noAwb: "POD માટે કોઈ AWB નથી",
    allDelivered: "બધા AWB ડિલિવર થઈ ગયા!",
    selectedAwb: "પસંદ કરેલ AWB",
    receiverName: "પ્રાપ્તકર્તાનું નામ",
    receiverMobile: "પ્રાપ્તકર્તાનો મોબાઇલ",
    enterReceiverName: "પ્રાપ્તકર્તાનું નામ દાખલ કરો",
    enterReceiverMobile: "10 અંકનો મોબાઇલ નંબર દાખલ કરો",
    submitPod: "POD સબમિટ કરો",
    cancel: "રદ કરો",
    success: "સફળ",
    podSuccess: "POD સફળતાપૂર્વક અપડેટ થયું!",
    inscanSuccess: "બેગ સ્વીકાર સફળતાપૂર્વક પૂર્ણ!",
    inscanConfirm: "બેગ પ્રાપ્તિની પુષ્ટિ કરો",
    inscanConfirmMsg: "શું તમે ખરેખર આ મધરબેગને પ્રાપ્ત તરીકે ચિહ્નિત કરવા માંગો છો?",
    yes: "હા, પુષ્ટિ કરો",
    no: "ના, રદ કરો",
    error: "ભૂલ",
    tryAgain: "કૃપા કરીને ફરી પ્રયાસ કરો",
    kg: "કિલો",
  },
};

type LangKey = "en" | "hi" | "gu";

const PublicMbagPod: React.FC = () => {
  const { id } = useParams();
  const [lang, setLang] = useState<LangKey>("en");
  const t = translations[lang];

  const [selectedAwbs, setSelectedAwbs] = useState<string[]>([]);
  const [showPodModal, setShowPodModal] = useState(false);
  const [showInscanConfirm, setShowInscanConfirm] = useState(false);
  const [receiverName, setReceiverName] = useState("");
  const [receiverMobile, setReceiverMobile] = useState("");
  const [toast, setToast] = useState<{ type: "success" | "error"; message: string } | null>(null);

  // Fetch motherbag data
  const { data, isLoading, isError, refetch } = useQuery(
    ["publicMbag", id],
    () => GetCommanWay(`/public/motherbag/${id}`, {}, {}),
    {
      enabled: !!id,
      retry: false,
    }
  );

  const mbagData = data?.data || null;
  const awbList = mbagData?.awbs || [];
  // API returns AWBs with pending POD (status null), so all AWBs in list are pending
  const pendingAwbs = awbList;

  // Inscan mutation
  const { mutate: doInscan, isLoading: inscanLoading } = useMutation(
    () => UpdateCommanWay({ url: `/public/motherbag/${id}/inscan`, data: {} }),
    {
      onSuccess: (res: any) => {
        if (res.status === "SUCCESS") {
          showToast("success", t.inscanSuccess);
          setShowInscanConfirm(false);
          refetch();
        } else {
          showToast("error", res.message || t.tryAgain);
        }
      },
      onError: () => {
        showToast("error", t.tryAgain);
      },
    }
  );

  // POD update mutation
  const { mutate: submitPod, isLoading: podLoading } = useMutation(
    (payload: { awb_nos: string[]; receiver_name: string; receiver_mobile: string }) =>
      CreateCommanWay({ url: `/public/motherbag/${id}/pod`, data: payload }),
    {
      onSuccess: (res: any) => {
        if (res.status === "SUCCESS") {
          showToast("success", t.podSuccess);
          setShowPodModal(false);
          setSelectedAwbs([]);
          setReceiverName("");
          setReceiverMobile("");
          refetch();
        } else {
          showToast("error", res.message || t.tryAgain);
        }
      },
      onError: () => {
        showToast("error", t.tryAgain);
      },
    }
  );

  const showToast = (type: "success" | "error", message: string) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3000);
  };

  const handleSelectAll = () => {
    if (selectedAwbs.length === pendingAwbs.length) {
      setSelectedAwbs([]);
    } else {
      setSelectedAwbs(pendingAwbs.map((a: any) => a.awb_no));
    }
  };

  const handleSelectAwb = (awbNo: string) => {
    if (selectedAwbs.includes(awbNo)) {
      setSelectedAwbs(selectedAwbs.filter((a) => a !== awbNo));
    } else {
      setSelectedAwbs([...selectedAwbs, awbNo]);
    }
  };

  const handleSubmitPod = async () => {
    if (!receiverName.trim() || !receiverMobile.trim()) {
      showToast("error", "Please fill all fields");
      return;
    }
    if (receiverMobile.length !== 10) {
      showToast("error", "Mobile number must be 10 digits");
      return;
    }

    // Submit POD with all selected AWBs
    submitPod({
      awb_nos: selectedAwbs,
      receiver_name: receiverName,
      receiver_mobile: receiverMobile
    });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (isError || !mbagData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-md w-full">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800">{t.notFound}</h1>
          <p className="text-lg text-gray-500 mt-2">{t.invalidLink}</p>
        </div>
      </div>
    );
  }

  const isOutscanDone = mbagData.outscanDone;
  const isInscanDone = mbagData.inscanDone;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 pb-8">
      {/* Toast */}
      {toast && (
        <div
          className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 px-6 py-4 rounded-lg shadow-lg text-white text-base font-medium ${
            toast.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {toast.message}
        </div>
      )}

      {/* Header with Airfield Branding */}
      <div className="bg-gradient-to-r from-[#001f3f] to-[#003366] shadow-lg sticky top-0 z-40">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-center gap-3">
          <img src="/images/logo.png" alt="Airfield" className="h-10 sm:h-12" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <h1 className="text-xl sm:text-2xl font-bold text-white tracking-wide">AIRFIELD EXPRESS</h1>
        </div>
      </div>

      {/* Language Switcher - Full Width */}
      <div className="bg-white border-b shadow-sm">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-center gap-2">
          {(["en", "hi", "gu"] as LangKey[]).map((l) => (
            <button
              key={l}
              onClick={() => setLang(l)}
              className={`px-5 py-2.5 text-base font-medium rounded-lg transition-all ${
                lang === l
                  ? "bg-indigo-600 text-white shadow-md"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              {l === "en" ? "English" : l === "hi" ? "हिंदी" : "ગુજરાતી"}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 pt-4">
        {/* Motherbag Info Card */}
        <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-6 mb-4">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 bg-indigo-100 rounded-xl flex items-center justify-center">
              <svg className="w-7 h-7 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div>
              <p className="text-base text-gray-500">{t.title}</p>
              <p className="text-xl font-bold text-gray-800">{mbagData.mother_bag_code}</p>
            </div>
            <div className="ml-auto">
              <span className={`px-4 py-1.5 rounded-full text-base font-medium ${
                mbagData.status === "PENDING" ? "bg-yellow-100 text-yellow-800" :
                mbagData.status === "SHORT" ? "bg-red-100 text-red-800" :
                "bg-green-100 text-green-800"
              }`}>
                {mbagData.status}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-base text-gray-500">{t.totalAwb}</p>
              <p className="text-lg font-semibold text-gray-800">{awbList.length || 0}</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-base text-gray-500">{t.totalWeight}</p>
              <p className="text-lg font-semibold text-gray-800">{awbList.reduce((sum: number, a: any) => sum + (a.weight || 0), 0).toFixed(2)} {t.kg}</p>
            </div>
          </div>
        </div>

        {/* Status Section */}
        {!isOutscanDone ? (
          // Outscan Pending
          <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6 text-center">
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-yellow-800">{t.outscanPending}</h2>
            <p className="text-lg text-yellow-700 mt-2">{t.outscanPendingMsg}</p>
          </div>
        ) : !isInscanDone ? (
          // Inscan Pending - Show Inscan Button
          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 text-center">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-blue-800">{t.inscanPending}</h2>
            <p className="text-lg text-blue-700 mt-2 mb-4">{t.inscanPendingMsg}</p>
            <button
              onClick={() => setShowInscanConfirm(true)}
              disabled={inscanLoading}
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold py-3 px-10 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {t.markInscan}
            </button>
          </div>
        ) : (
          // Inscan Done - Show AWB List
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="bg-gradient-to-r from-green-500 to-green-600 px-4 py-4">
              <div className="flex items-center justify-between">
                <h2 className="text-lg text-white font-bold">{t.awbList}</h2>
                <span className="bg-white/20 text-white text-base px-4 py-1 rounded-full">
                  {pendingAwbs.length} {t.pending}
                </span>
              </div>
            </div>

            {pendingAwbs.length === 0 ? (
              <div className="p-8 text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-lg text-gray-600 font-medium">{t.allDelivered}</p>
              </div>
            ) : (
              <>
                {/* Select All */}
                <div className="px-4 py-4 border-b bg-gray-50 flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={selectedAwbs.length === pendingAwbs.length && pendingAwbs.length > 0}
                    onChange={handleSelectAll}
                    className="w-6 h-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  />
                  <span className="text-lg font-medium text-gray-700">{t.selectAll}</span>
                </div>

                {/* AWB List */}
                <div className="divide-y max-h-[400px] overflow-y-auto">
                  {pendingAwbs.map((awb: any) => (
                    <div
                      key={awb.awb_no}
                      className={`px-4 py-4 flex items-center gap-3 cursor-pointer hover:bg-gray-50 transition-colors ${
                        selectedAwbs.includes(awb.awb_no) ? "bg-indigo-50" : ""
                      }`}
                      onClick={() => handleSelectAwb(awb.awb_no)}
                    >
                      <input
                        type="checkbox"
                        checked={selectedAwbs.includes(awb.awb_no)}
                        onChange={() => {}}
                        className="w-6 h-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 flex-shrink-0"
                      />
                      <div className="flex-1 min-w-0">
                        <p className="text-base font-semibold text-gray-800">{awb.awb_no}</p>
                        <p className="text-base text-gray-500 truncate">{awb.consignee || "-"}</p>
                        <p className="text-sm text-gray-400">{awb.destination} - {awb.pincode}</p>
                      </div>
                      <div className="text-right flex-shrink-0">
                        <p className="text-base font-medium text-gray-600">{awb.weight} {t.kg}</p>
                        <p className="text-sm text-gray-400">{awb.contact_no}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Submit Button */}
                {selectedAwbs.length > 0 && (
                  <div className="p-4 bg-gray-50 border-t">
                    <button
                      onClick={() => setShowPodModal(true)}
                      className="w-full bg-indigo-600 hover:bg-indigo-700 text-white text-lg font-bold py-4 rounded-xl transition-all"
                    >
                      {t.submitPod} ({selectedAwbs.length})
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>

      {/* POD Modal */}
      {showPodModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4">
          <div className="bg-white rounded-t-3xl sm:rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-5 border-b flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-800">{t.submitPod}</h3>
              <button
                onClick={() => setShowPodModal(false)}
                className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center"
              >
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-5 space-y-5">
              {/* Selected AWBs */}
              <div className="bg-indigo-50 rounded-xl p-4">
                <p className="text-base text-indigo-600 font-medium mb-2">{t.selectedAwb}</p>
                <div className="flex flex-wrap gap-2">
                  {selectedAwbs.map((awb) => (
                    <span key={awb} className="bg-white px-4 py-1.5 rounded-lg text-base font-medium text-gray-700">
                      {awb}
                    </span>
                  ))}
                </div>
              </div>

              {/* Receiver Name */}
              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">{t.receiverName} *</label>
                <input
                  type="text"
                  value={receiverName}
                  onChange={(e) => setReceiverName(e.target.value)}
                  placeholder={t.enterReceiverName}
                  className="w-full px-4 py-4 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                />
              </div>

              {/* Receiver Mobile */}
              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">{t.receiverMobile} *</label>
                <input
                  type="tel"
                  value={receiverMobile}
                  onChange={(e) => setReceiverMobile(e.target.value.replace(/\D/g, "").slice(0, 10))}
                  placeholder={t.enterReceiverMobile}
                  className="w-full px-4 py-4 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                />
              </div>

              {/* Buttons */}
              <div className="flex gap-3 pt-2">
                <button
                  onClick={() => setShowPodModal(false)}
                  className="flex-1 py-4 text-base border border-gray-300 rounded-xl font-medium text-gray-700 hover:bg-gray-50 transition-all"
                >
                  {t.cancel}
                </button>
                <button
                  onClick={handleSubmitPod}
                  disabled={podLoading}
                  className="flex-1 py-4 text-base bg-green-600 hover:bg-green-700 text-white font-bold rounded-xl transition-all disabled:opacity-50"
                >
                  {podLoading ? "..." : t.submitPod}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Inscan Confirmation Modal */}
      {showInscanConfirm && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-sm p-6 text-center">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">{t.inscanConfirm}</h3>
            <p className="text-base text-gray-600 mb-6">{t.inscanConfirmMsg}</p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowInscanConfirm(false)}
                className="flex-1 py-3 text-base border border-gray-300 rounded-xl font-medium text-gray-700 hover:bg-gray-50 transition-all"
              >
                {t.no}
              </button>
              <button
                onClick={() => doInscan()}
                disabled={inscanLoading}
                className="flex-1 py-3 text-base bg-green-600 hover:bg-green-700 text-white font-bold rounded-xl transition-all disabled:opacity-50"
              >
                {inscanLoading ? "..." : t.yes}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicMbagPod;
